import { requestAppConfigAdmin } from './auth';
const BASE = '/api/v0/mobile/release-planning';
export async function listReleaseContent(environment) {
  const result = await requestAppConfigAdmin(`${BASE}?resource=content`, { expectedEnvironment: environment });
  return result?.items || [];
}
export function saveReleaseContent(row, payload, environment) {
  return requestAppConfigAdmin(row ? `${BASE}?id=${encodeURIComponent(row.id)}` : BASE, {
    method: row ? 'PATCH' : 'POST', expectedEnvironment: environment,
    body: JSON.stringify({ resource: 'content', ...(row ? { revision: row.revision, action: 'UPDATE' } : {}), ...payload }),
  });
}
export function approveReleaseContent(row, environment) {
  return requestAppConfigAdmin(`${BASE}?id=${encodeURIComponent(row.id)}`, {
    method: 'PATCH', expectedEnvironment: environment,
    body: JSON.stringify({ resource: 'content', revision: row.revision, action: 'APPROVE' }),
  });
}
export function getReviewerProfileStatus(environment) {
  return requestAppConfigAdmin(`${BASE}?resource=reviewer_profile`, { expectedEnvironment: environment, cache: 'no-store' });
}
// This result contains review access. Call imperatively, never through QueryClient/storage/logging.
export function exportPrivateReview(row, environment) {
  return requestAppConfigAdmin(`${BASE}?resource=review_export&version_name=${encodeURIComponent(row.version_name)}&revision=${encodeURIComponent(row.revision)}`, { expectedEnvironment: environment, cache: 'no-store' });
}
